// src/utils/defaultErrorHandler.ts
async function defaultErrorHandler(error) {
  throw error;
}
export {
  defaultErrorHandler as default
};
